import * as VueRouter from 'vue-router'
import { api_host } from './constants'
import { getAuthState, setAuthState } from './service/authState'
import SiteEditor from './views/SiteEditor'
import SitesList from './views/SitesList'
import Login from './views/Login'
import Register from './views/Register'
import Permission from './views/Permission'
import ResetPassword from './views/ResetPassword'
import UserManagementView from './views/UserManagementView'
import Settings from './views/Settings'
import UserConfirmationOTP from './views/UserConfirmationOTP'
import ForgotPassword from "./views/ForgotPassword";
import ConfirmForgotPassword from "./views/ConfirmForgotPassword";
import GlobalComponents from "./views/GlobalComponents";
import ComponentEdit from './views/ComponentEdit.vue'
import AssetList from './views/AssetList.vue'
import AuditLogs from './views/AuditLogs.vue'

const routes = [
  { name: 'Login', path: '/login', component: Login },
  { name: 'Register', path: '/register', component: Register },
  { name: 'UserConfirmationOTP', path: '/email-verification', component: UserConfirmationOTP },
  { name: 'ForgotPassword', path: '/forgot-password', component: ForgotPassword },
  { name: 'ConfirmForgotPassword', path: '/confirm-forgot-password', component: ConfirmForgotPassword },
  { name: 'ResetPassword', path: '/reset-password', component: ResetPassword },
  { name: 'SitesList', path: '/site-list', component: SitesList, meta: { requiresAuth: true } },
  { name: 'GlobalComponents', path: '/component-list', component: GlobalComponents, meta: { requiresAuth: true } },
  { name: 'AssetList', path: '/asset-list', component: AssetList, meta: { requiresAuth: true } },
  { name: 'UserManagementView', path: '/users', component: UserManagementView, meta: { requiresAuth: true } },
  { name: 'SiteEditor', path: '/site-edit/:uri', component: SiteEditor, meta: { requiresAuth: true } },
  { name: 'ComponentEdit', path: '/comp-edit/:id', component: ComponentEdit, meta: { requiresAuth: true } },
  { name: 'ComponentsEditor', path: '/global-components', component: SiteEditor, props: { isComponentView: true }, meta: { requiresAuth: true } },
  { name: 'Permission', path: '/site-permission', component: Permission, meta: { requiresAuth: true } },
  { name: 'Settings', path: '/settings', component: Settings, meta: { requiresAuth: true } },
  { name: 'AuditLogs', path: '/audit-logs/:siteId/:uri', component: AuditLogs, meta: { requiresAuth: true } },
  { path: '/', redirect: '/site-list' }
]

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes
})

const verifySession = async () => {
  if (getAuthState() !== null) return getAuthState()
  try {
    const res = await fetch(`${api_host}/auth/user/me`, { credentials: 'include' })
    if (res.ok) {
      setAuthState(true)
      return true
    }
    if (res.status === 401) {
      const refresh = await fetch(`${api_host}/auth/refresh-token`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      })
      setAuthState(refresh.ok)
      return refresh.ok
    }
  } catch {
    // network error — treat as unauthenticated
  }
  setAuthState(false)
  return false
}

// Routes where an already-authenticated user should be sent away to the app
const REDIRECT_AWAY_WHEN_AUTHED = ['Login', 'Register']

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const authed = await verifySession()
    if (!authed) {
      return next({ name: 'Login', query: { redirect: to.fullPath } })
    }
  } else if (REDIRECT_AWAY_WHEN_AUTHED.includes(to.name)) {
    const authed = await verifySession()
    if (authed) {
      return next({ name: 'SitesList' })
    }
  }
  next()
})

export default router